import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { urlDetector } from './detectors/urlDetector';
import { NamespacesI18n, resourcesApp } from './index';

const resources = resourcesApp;
const languageDetector = new LanguageDetector(null, { order: ['url'] });
languageDetector.addDetector(urlDetector);

const instance = i18n;
if (initReactI18next) instance.use(initReactI18next);
instance.use(languageDetector).init({
  fallbackLng: 'en_US',
  /// https://www.i18next.com/how-to/faq#how-should-the-language-codes-be-formatted
  defaultNS: [NamespacesI18n.COMMON],
  fallbackNS: NamespacesI18n.COMMON,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  ns: Object.values(NamespacesI18n),
  resources,
});

export default instance;
